define('model/assignment.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var AssignmentModel = BaseModel.extend({
    radioRequests: {
      'models AssignmentModel': '@constructor',
    },
    urlRoot: '/api/v1/iacuc-aggregator/assignment',

    relationships: {
      userModel: {
        type: 'belongsTo',
        foreignKey: 'userId',
        resourceClass: 'UserModel',
      },
      personModel: {
        fetchMode: 'manual',
        type: 'belongsTo',
        foreignKey: 'personId',
        resourceClass: 'PersonModel',
      },
    },
  });

  module.exports = AssignmentModel;
});

